/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateUserTabDto } from '../../models/create-user-tab-dto';
import { PosTab } from '../../models/pos-tab';

export interface PosTabsControllerCreateUserTab$Params {
      body: CreateUserTabDto
}

export function posTabsControllerCreateUserTab(http: HttpClient, rootUrl: string, params: PosTabsControllerCreateUserTab$Params, context?: HttpContext): Observable<StrictHttpResponse<PosTab>> {
  const rb = new RequestBuilder(rootUrl, posTabsControllerCreateUserTab.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PosTab>;
    })
  );
}

posTabsControllerCreateUserTab.PATH = '/pos/tabs/user';
